module.exports = __webpack_public_path__ + "static/media/ICT-3.c8d0f9be.png";